import { Box, makeStyles } from "@material-ui/core";
import { ArrowForward, WarningOutlined } from "@material-ui/icons";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { SKButton, SKCard, SKTypography } from "../../ui";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  expiredCard: {
    background: "linear-gradient(135deg, #ffffff 0%, #fff5f5 100%)",
    border: "1px solid #fed7d7",
    borderRadius: 16,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
    overflow: "hidden",
    position: "relative",
    transition: "all 0.3s ease",
    // "&:hover": {
    //   boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04)",
    //   transform: "translateY(-2px)",
    // },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: 6,
      height: "100%",
      backgroundColor: "#e53e3e",
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    padding: theme.spacing(3, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5, 3),
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: "#fff5f5",
    border: "2px solid #fed7d7",
    color: "#e53e3e",
    flexShrink: 0,
    animation: "$pulse 2s infinite",
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(229, 62, 62, 0.4)",
    },
    "70%": {
      boxShadow: "0 0 0 10px rgba(229, 62, 62, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(229, 62, 62, 0)",
    },
  },
  textContainer: {
    flexGrow: 1,
  },
  title: {
    fontWeight: 800,
    color: "#2d3748",
    marginBottom: theme.spacing(0.5),
    fontSize: "1.1rem",
  },
  description: {
    color: "#718096",
    fontSize: "0.9rem",
    lineHeight: 1.6,
  },
  actionWrapper: {
    flexShrink: 0,
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
  },
  renewButton: {
    backgroundColor: "#e53e3e",
    color: "#fff",
    padding: theme.spacing(1, 3),
    fontWeight: 700,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "#c53030",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

const AccountExpiredAlert = ({ title, description, buttonLabel, buttonDisabled = false, onAction, className = "" }) => {
  const classes = useStyles();
  const router = useRouter();
  const { t } = useTranslation("common");

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else {
      router.push("/subscription");
    }
  };

  return (
    <Box className={`${classes.root} ${className}`}>
      <SKCard className={classes.expiredCard} variant="static">
        <Box className={classes.content}>
          <Box className={classes.iconWrapper}>
            <WarningOutlined fontSize="large" />
          </Box>
          <Box className={classes.textContainer}>
            <SKTypography variant="h6" className={classes.title}>
              {title || t("Subscription Expired")}
            </SKTypography>
            <SKTypography variant="body2" className={classes.description}>
              {description ||
                t(
                  "Your account subscription has expired. Please renew your subscription to continue using all premium features and manage your properties.",
                )}
            </SKTypography>
          </Box>
          <Box className={classes.actionWrapper}>
            <SKButton
              variant="contained"
              onClick={handleAction}
              endIcon={<ArrowForward />}
              className={classes.renewButton}
              disabled={buttonDisabled}
            >
              {buttonLabel || t("Renew Now")}
            </SKButton>
          </Box>
        </Box>
      </SKCard>
    </Box>
  );
};

export default AccountExpiredAlert;
